import { createSelector } from 'reselect'
import config from 'constants/config'
import { setCookie } from 'lib/web/cookieUtils'
import { OptimizelyExperiments, OptimizelyFeatureFlags } from 'constants/optimizely'
import { DurationSeconds } from 'lib/datetime/durationInSeconds'

export function setOptimizelyTriggeredCookie(flagKey: OptimizelyExperiments) {
  setCookie(`${flagKey}_triggered`, 't', DurationSeconds.SIXTY_DAYS, '/', 'Lax')
}

const allFeatureFlags = new Set(Object.values(OptimizelyFeatureFlags))
export function isFeatureFlagExperiment(experimentId: OptimizelyExperiments | OptimizelyFeatureFlags): experimentId is OptimizelyFeatureFlags {
  return typeof experimentId === 'string' && allFeatureFlags.has(experimentId as OptimizelyFeatureFlags)
}

export const getOptimizelyExperimentVariation = createSelector(
  (_: App.State, experimentId: OptimizelyExperiments) => experimentId,
  (state: App.State, experimentId: OptimizelyExperiments) => state.optimizely.optimizelyExperiments[experimentId],
  (experimentId, experiment): string | undefined => {
    // For devs to set a specific variation locally. Set REACT_APP_OPTIMIZELY_[experimentId]=true for variant or false for control in .env,
    if (config[`OPTIMIZELY_${experimentId}`] !== undefined) { return config[`OPTIMIZELY_${experimentId}`] }
    if (!experiment?.enabled) {
      return
    }

    if (experiment.enabled && Object.keys(experiment.variables).length) {
      return experiment.variables[experiment.variationKey]
    }

    return experiment.variationKey
  },
)

export function getOptimizelyFeatureFlagVariation(state: App.State, experimentId: OptimizelyFeatureFlags) {
  return !!state.optimizely.optimizelyFeatureFlags[experimentId]
}

export function getOptimizelyEnabledDecision(experimentVariationKey: string | null): boolean {
  const normalizedVariationKey = experimentVariationKey?.toLowerCase()
  return !!(normalizedVariationKey && (normalizedVariationKey !== 'off' && normalizedVariationKey !== 'control'))
}

// exclude all gha redirections from the experiment
export function isGHARedirection(utmContent?: string): boolean {
  return utmContent === 'gha-lpp' || utmContent === 'gha-lpc'
}

export function isAllowedToTriggerExperiment(canTrigger: boolean, utmContent?: string, experimentId?: string): boolean {
  return canTrigger && (!isGHARedirection(utmContent) || !!config.ALLOWED_METASEARCH_EXPERIMENTS?.includes(experimentId || ''))
}
